import { LicenseManager } from 'ag-grid-enterprise'

LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-084999}_in_excess_of_the_licence_granted_is_not_permitted___' +
  'Please_report_misuse_to_legal@ag-grid.com___' +
  'For_help_with_changing_this_key_please_contact_info@ag-grid.com___' +
  '{ACV_Auctions}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{MAX_Inventory}_only_for_{5}_Front-End_JavaScript_developers___' +
  'All_Front-End_JavaScript_developers_working_on_{MAX_Inventory}_need_to_be_licensed___' +
  '{MAX_Inventory}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___' +
  'This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{22_December_2026}____' +
  '[v3]_[01]_MTc5Nzg5NzYwMDAwMA==571dac602e8785c76b38e9cf1d96feb4'
)
